/* @ngInject */

export default (
  $rootScope,
  dateTimeService,
  FundingWorksheetOtherDebt,
  OwnershipType,
  TransactionType
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function FundingWorksheetFundsRequiredSplit(
    id,
    idSecurity,
    purposeFunds,
    transactionType,
    lenderAbbreviations,
    ownershipType,
    propertyStatus,
    constructionType,
    constructionPropertyType,
    landValue,
    contractDate,
    builderContractPrice,
    loanAmountToRefinance,
    exitFee,
    existingLoanBalance,
    otherLoansAgainstSecurity,
    lmiPremiumAlreadyPaid,
    firstHomeConcession,
    offThePlan,
    stampDuty,
    isEditStampDuty,
    lenderFees,
    legalFees,
    mortgageDischargeCosts,
    isMortgageDischargeCostsEdited,
    landTransferFees,
    isEditLandTransferFees,
    mortgageRegistrationFees,
    isEditMortgageRegistrationFees,
    otherFees,
    otherDebts
  ) {
    this.id = id;
    this.idSecurity = idSecurity;
    this.purposeFunds = purposeFunds;
    this.transactionType = transactionType;
    this.lenderAbbreviations = lenderAbbreviations;
    this.ownershipType = ownershipType;
    this.propertyStatus = propertyStatus;
    this.constructionType = constructionType;
    this.constructionPropertyType = constructionPropertyType;
    this.landValue = landValue;
    this.contractDate = contractDate;
    this.builderContractPrice = builderContractPrice;
    this.loanAmountToRefinance = loanAmountToRefinance;
    this.exitFee = exitFee;
    this.existingLoanBalance = existingLoanBalance;
    this.otherLoansAgainstSecurity = otherLoansAgainstSecurity;
    this.lmiPremiumAlreadyPaid = lmiPremiumAlreadyPaid;
    this.firstHomeConcession = firstHomeConcession;
    this.offThePlan = offThePlan;
    this.stampDuty = stampDuty;
    this.isEditStampDuty = isEditStampDuty;
    this.lenderFees = lenderFees;
    this.legalFees = legalFees;
    this.mortgageDischargeCosts = mortgageDischargeCosts;
    this.isMortgageDischargeCostsEdited = isMortgageDischargeCostsEdited;
    this.landTransferFees = landTransferFees;
    this.isEditLandTransferFees = isEditLandTransferFees;
    this.mortgageRegistrationFees = mortgageRegistrationFees;
    this.isEditMortgageRegistrationFees = isEditMortgageRegistrationFees;
    this.otherFees = otherFees;
    this.otherDebts = otherDebts;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheetFundsRequiredSplit.Blank = function () {
    return FundingWorksheetFundsRequiredSplit.Build({
      id: _.uuid(),
      idSecurity: '',
      purposeFunds: 0,
      transactionType: TransactionType.none,
      lenderAbbreviations: '',
      ownershipType: OwnershipType.none,
      propertyStatus: 0,
      constructionType: 0,
      constructionPropertyType: 0,
      landValue: 0,
      contractDate: 0,
      builderContractPrice: 0,
      loanAmountToRefinance: 0,
      exitFee: 0,
      existingLoanBalance: 0,
      otherLoansAgainstSecurity: 0,
      lmiPremiumAlreadyPaid: 0,
      firstHomeConcession: false,
      offThePlan: false,
      stampDuty: 0,
      isEditStampDuty: false,
      lenderFees: 0,
      legalFees: 0,
      mortgageDischargeCosts: 0,
      isMortgageDischargeCostsEdited: false,
      landTransferFees: 0,
      isEditLandTransferFees: false,
      mortgageRegistrationFees: 0,
      isEditMortgageRegistrationFees: false,
      otherFees: 0,
      otherDebts: []
    });
  };
  FundingWorksheetFundsRequiredSplit.Build = function (data) {
    return new FundingWorksheetFundsRequiredSplit(
      data.id ? data.id : _.uuid(),
      data.idSecurity || '',
      data.purposeFunds || 0,
      TransactionType.of(data?.transactionType?.name || data?.transactionType?.toString()),
      data.lenderAbbreviations || '',
      OwnershipType.of(data.ownershipType?.name || data?.ownershipType?.toString()),
      data.propertyStatus || 0,
      data.constructionType || 0,
      data.constructionPropertyType || 0,
      data.landValue || 0,
      data.contractDate || 0,
      data.builderContractPrice || 0,
      data.loanAmountToRefinance || 0,
      data.exitFee || 0,
      data.existingLoanBalance || 0,
      data.otherLoansAgainstSecurity || 0,
      data.lmiPremiumAlreadyPaid || 0,
      data.firstHomeConcession || false,
      data.offThePlan || false,
      data.stampDuty || 0,
      data.isEditStampDuty || false,
      data.lenderFees || 0,
      data.legalFees || 0,
      data.mortgageDischargeCosts || 0,
      data.isMortgageDischargeCostsEdited || false,
      data.landTransferFees || 0,
      data.isEditLandTransferFees || false,
      data.mortgageRegistrationFees || 0,
      data.isEditMortgageRegistrationFees || false,
      data.otherFees || 0,
      _.map(_.compact(data.otherDebts), (otherDebt) =>
        FundingWorksheetOtherDebt.Build(otherDebt)
      )
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheetFundsRequiredSplit.prototype.getSetContractDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (this.contractDate === 0) {
          this.contractDateObject = '';
        }
        const contractDateObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.contractDateObject = date;
        this.contractDate = moment.utc(contractDateObject).startOf('day').format('X');
      } else {
        this.contractDateObject = date;
        this.contractDate = '';
      }
    }
    if (!this.contractDateObject) {
      if (this.contractDate !== 0) {
        const contractDateObject = dateTimeService.setDate(
          this.contractDate,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.contractDateObject = contractDateObject;
      } else {
        this.contractDateObject = '';
      }
    }
    return this.contractDateObject;
  };
  FundingWorksheetFundsRequiredSplit.prototype.deleteDateObject = function () {
    delete this.contractDateObject;
  };

  return FundingWorksheetFundsRequiredSplit;
};
